import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist-indexeddb-storage'

import VNAndroidSDK from '../VNAndroidSDK/Reducer'
import VNCategories from '../VNCategories/Reducer'
import VNCustomerFacingDisplay from '../VNCustomerFacingDisplay/Reducer'
import PersistedVNCustomerFacingDisplay from '../VNCustomerFacingDisplay/ReducerPersisted'
import VNMode from '../VNMode/Reducer'
import VNDialogs from '../VNDialogs/Reducer'
import VNTabs from '../VNTabs/Reducers'
import VNTransactions from '../VNTransactions/Reducers'
import VNTestMode from '../VNTestMode/Reducers'
import VNPPI from '../VNPPI/Reducer'
import VNRoutes from '../VNRoutes/Reducers'
import VNLoader from '../VNLoader/Reducer'
import VNMobileScanner from '../VNMobileScanner/Reducer'
import VNLocationPicker from '../VNLocationPicker/Reducer'
import VNManagerApproval from '../VNManagerApproval/Reducer'
import VNConfigurations from '../VNConfigurations/Reducer'
import VNPusher from '../VNPusher/Reducer'
import VNPayments from '../VNPayments/Reducers'
import VNOrders from '../VNOrders/Reducer'
import VNOrdersPersisted from '../VNOrders/ReducerPersisted'
import VNTenders from '../VNTenders/Reducers'
import VNInvoiceManager from '../VNInvoiceManager/Reducer'
import VNTaxes from '../VNTaxes/Reducers'
import VNSyncManager from '../VNSyncManager/Reducer'
import VNDataLoadManager from '../VNDataLoadManager/Reducer'
import VNUpdateManager from '../VNUpdateManager/Reducer'

// KIOSK
import appState from './appState'
import categories from './categories'
import items from './items'
import stands from './stands'
import menus from './menus'
import kioskCarouselImages from './carouselImages'

// POS
import cart from './cart'
import order from './order'
import revenueCenter from './revenueCenter'
import search from './search'
import attendant from './attendant'
import attendantSettings from './attendantSettings'
import venue from './venue'
import printer from './printer'
import orderTotalRemote from './orderTotalRemote'
import promotion from './promotion'

// SHARED
import refund from './refund'
import config from './config'
import peripheral from './peripheral'
import { IDB_PERSIST_NAME, IDB_PERSIST_VERSION, PERSIST_HYDRATE_TIMEOUT } from '../VNDatabase/setup/vars'

const configPersistConfig = {
  key: 'config',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: ['shouldRefreshConfig', 'remote'],
}

const revenueCenterPersistConfig = {
  key: 'revenueCenter',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
}

const attendantPersistConfig = {
  key: 'attendant',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: ['activeAttendantId', 'attemptPinLoginStatus'],
}

const peripheralPersistConfig = {
  key: 'peripheral',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: ['peripheralIsBusy', 'safIsUploading'],
}

const cartPersistConfig = {
  key: 'cart',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: [],
}

const itemsStatePersistConfig = {
  key: 'items',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: [],
}

const orderPersistConfig = {
  key: 'order',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: ['orderInProgress'],
}

const appStatePersistConfig = {
  key: 'appState',
  timeout: PERSIST_HYDRATE_TIMEOUT,
  storage: storage(IDB_PERSIST_NAME, IDB_PERSIST_VERSION),
  blacklist: ['automaticallyUpdate', 'performSafeUpdate', 'updateAvailable'],
}

export default combineReducers({
  appState: persistReducer(appStatePersistConfig, appState),
  categories,
  items: persistReducer(itemsStatePersistConfig, items),
  stands,
  menus,
  kioskCarouselImages,
  revenueCenter: persistReducer(revenueCenterPersistConfig, revenueCenter),
  cart: persistReducer(cartPersistConfig, cart),
  order: persistReducer(orderPersistConfig, order),
  orderTotalRemote,
  refund,
  peripheral: persistReducer(peripheralPersistConfig, peripheral),
  config: persistReducer(configPersistConfig, config),
  search,
  attendant: persistReducer(attendantPersistConfig, attendant),
  attendantSettings,
  venue,
  printer,
  promotion,
  VNAndroidSDK,
  VNCategories,
  VNCustomerFacingDisplay,
  PersistedVNCustomerFacingDisplay,
  VNMode,
  VNDialogs,
  VNTabs,
  VNTransactions,
  VNPayments,
  VNPPI,
  VNRoutes,
  VNLoader,
  VNManagerApproval,
  VNMobileScanner,
  VNLocationPicker,
  VNConfigurations,
  VNPusher,
  VNOrders,
  VNOrdersPersisted,
  VNTenders,
  VNInvoiceManager,
  VNTaxes,
  VNSyncManager,
  VNDataLoadManager,
  VNTestMode,
  VNUpdateManager,
})
